module.exports = __webpack_public_path__ + "static/1-8230d360865922dbbb66998c4ce2ab65.jpg";